import { gql, useQuery } from '@apollo/client';

export const GET_QUESTIONNAIRES_SETTINGS_BY_ID = gql`
  query getEmployeeQuestionnaireSettingById($id: String!) {
    getEmployeeQuestionnaireSettingById(id: $id) {
        _id
        settings
        name
        companyId
        supervisorEmailTemplateId
        applicantEmailTemplateId
        privacyPolicyLink
        createdBy
        miniJobDocumentId
        miniJobDocument {
            filename
            location
            key
        }
    }
  }
`;

export const useGetEmployeeQuestionnaireSettingById = (id: string) => {
  const { data, loading } = useQuery(GET_QUESTIONNAIRES_SETTINGS_BY_ID, {
    variables: { id },
    skip: !id,
  });

  const questionnaireSetting = data?.getEmployeeQuestionnaireSettingById || {};

  return { questionnaireSetting, loading };
};
